/**
 * LA FECHA DE NACIMIENTO, COMPROBADA POR LA EDAD QUE PRODUCE.
 *
 * El servidor la valida así desde el 26-08 (`validar_fecha_de_nacimiento` en
 * `backend/models/user.py`): la fecha no tiene rango propio, lo tiene la EDAD, y son 14 a
 * 100 años. Aquí va la misma regla y con los mismos números, para que la pantalla diga lo
 * mismo que va a decir el servidor y no se entere el cliente al guardar.
 *
 * POR QUÉ HACÍA FALTA (Jesús, 9-09). Se atascó rellenando su perfil con «Revisa tu fecha de
 * nacimiento: no hemos podido guardarlo así», y no había forma de salir de ahí: su ficha
 * tenía guardado 26-07-2026 -- de hace seis semanas, edad -1 --, el cuestionario largo la
 * cargaba, daba la pregunta por contestada y se la saltaba, y al terminar la mandaba tal
 * cual. El servidor la rechazaba, con razón, y él no tenía ninguna pantalla donde
 * corregirla. En producción había ocho fichas igual de atascadas.
 *
 * Así que una fecha imposible NO cuenta como contestada: se vuelve a preguntar.
 */
export const EDAD_MINIMA = 14;
export const EDAD_MAXIMA = 100;

/** Los años que tiene hoy quien nació ese día. `null` si eso no es una fecha. */
export function edadDe(valor) {
    if (valor === null || valor === undefined || `${valor}`.trim() === '') return null;
    const texto = String(valor).slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(texto)) return null;
    // A mediodía: a las 00:00 el cambio de hora puede dejar la fecha en el día de antes.
    const nacimiento = new Date(`${texto}T12:00:00`);
    if (isNaN(nacimiento)) return null;
    const hoy = new Date();
    const cumplioYa = hoy.getMonth() > nacimiento.getMonth()
        || (hoy.getMonth() === nacimiento.getMonth() && hoy.getDate() >= nacimiento.getDate());
    return hoy.getFullYear() - nacimiento.getFullYear() - (cumplioYa ? 0 : 1);
}

/** ¿Se puede guardar esa fecha? Vacía es `false`: no hay nada que guardar. */
export function fechaDeNacimientoUsable(valor) {
    const edad = edadDe(valor);
    return edad !== null && edad >= EDAD_MINIMA && edad <= EDAD_MAXIMA;
}

/**
 * Qué le pasa a esa fecha, dicho para una persona. `null` si está bien o si está vacía
 * (que el campo esté en blanco lo dice el «te falta un campo», no un aviso de error).
 */
export function porQueNoValeLaFecha(valor) {
    if (valor === null || valor === undefined || `${valor}`.trim() === '') return null;
    const edad = edadDe(valor);
    if (edad === null) return 'Escríbela como día, mes y año.';
    if (edad < EDAD_MINIMA || edad > EDAD_MAXIMA) {
        return `Con esa fecha saldrían ${edad} años. Revísala.`;
    }
    return null;
}

export default fechaDeNacimientoUsable;
